import { loginApi } from "../../apis/login";
import { loginError, loginStart, loginSuccess, logoutSuccess, logoutFailure } from "../constants/login";
import { showNotification } from "./notification";
import { preserveLoginData, deleteLoginData } from "../../utls/localStorage";
import { message } from "antd";

export function startLogin() {
  return {type: loginStart}
}

export function successLogin(payload) {
  return { type: loginSuccess, payload: payload };
}

export function loginFail() {
  return { type: loginError }
}

export function logoutSuccessful() {
  return { type: logoutSuccess }
}

export function login(payload, navigate) {
  return async (dispatch) => {
    dispatch(startLogin());
    loginApi(payload).then(
      (res) => {
        dispatch(successLogin(res));
        preserveLoginData(res);
        dispatch(showNotification({
          type: 'success',
          message: 'Success',
          description: 'Logged in Successfully',
        }));
        if (navigate && typeof navigate === 'function') {
          navigate('/superadmin/home');
        }
      },
      (error) => {
        dispatch(loginFail());
        dispatch(showNotification({
          type: 'error',
          message: 'Failure',
          description: 'Unable to Login',
        }));
      }
    )
  }
}

export function logout() {
  return((dispatch) => {
    dispatch(logoutSuccessful());
    deleteLoginData();
    dispatch(showNotification({
      type: "success",
      message: "Success",
      description: "You have been logged out successfully"
    }))
  })
}
